import CartController from "emun.cart/cart.controller";

export default (templateUrl, bindings) => ({
  bindings,
  controller: CartController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
});
